import { Route } from '@angular/router';
import channelsRoutes from '../features/channels/channels.routes';

export const appRoutes: Array<Route> = [...channelsRoutes];
